<template>
  <public-header></public-header>
  <div id="spacer"></div>
  <div id="content">
    <p>
      Thank you for registering! Please check your email for set-up
      instructions.
    </p>
  </div>
</template>

<script>
import PublicHeader from '@/components/Public-Header';

export default {
  name: 'RegisterComplete',
  components: { 'public-header': PublicHeader }
};
</script>

<style scoped>
#spacer {
  height: 100px;
}
.error {
  color: red;
  font-size: 18px;
}
input {
  width: 400px;
  padding: 15px;
  margin: 10px;
  font-size: 20px;
}

button {
  width: 400px;
  height: 50px;
  font-size: 100%;
}

#content {
  text-align: center;
}

p {
  font-size: 20px;
  color: blue;
}
</style>
